import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LicenseModel } from './../models/LicenseModel/LicenseModel';
import { RequestHandlerService,AuthService, RequestOptionsModel } from "bbsf-utilities";


@Injectable({
  providedIn: 'root'
})
export class LicenseService {
  ApiUrl = "/api/admin/LicenseAdmin/"
  constructor(private http: RequestHandlerService) {
  }

  GetOrganizationLicense()
  {
    
    return this.http.get(this.ApiUrl +'GetOrganizationLicense');
  }


  UploadLicense(File:LicenseModel) {
    return this.http.post(this.ApiUrl + 'UploadLicense', File);
  }
  
}